module.exports = __webpack_public_path__ + "img/第1章_2-2_名片與簽名.jpg";